import {calcUserScore, filterObjectByParams} from 'helpers/common-helper';
import BasePlayer from 'services/sports/default/base-player';
import {getDefaultExposure} from 'helpers/player-helper';
import {SearchRuleBuilder as RuleBuilder} from 'services/search-rule-builder';
import Action from 'actions';
import {PlayersPoolBuilder} from 'services/players-pool/players-pool-builder';
import {getPlayerProjOwnFunctionality} from 'helpers/projected-ownership';

export default class Player extends BasePlayer {
    getExpandedEntityParams({incomingValues = {}}) {
        const {userPointsType = 'adminPoints'} = incomingValues;
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});
        const userPoints = parseFloat(expandedPlayer[userPointsType]);

        return {
            ...expandedPlayer,
            userPoints,
            userScore: calcUserScore(userPoints, expandedPlayer.salary, this.userScoreMultiplier),
            projOwn: {...getPlayerProjOwnFunctionality(expandedPlayer)},
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
            },
        };
    }

    preparePoolsOfPlayers({incomingValues: {players, filterPlayersBeforePreparingPools}}) {
        if (!filterPlayersBeforePreparingPools) {
            return this.exec('createPoolsOfPlayers', {
                players: Object.values(players),
            });
        }

        const params = {
            ...RuleBuilder.callback('playerId', function (player) {
                return !player.isExcludedAnywhere();
            }),
        };

        players = filterObjectByParams(players, params, true);

        return this.exec('createPoolsOfPlayers', {
            players,
        });
    }

    createPoolsOfPlayers({incomingValues: {players}}) {
        const {playersLock} = Action.getState();

        let builder = new PlayersPoolBuilder(players);

        builder.addTaskOnScenario('position');
        builder.addTaskOnScenario('playerId');
        builder.addTaskOnScenario('teamAndPosition');
        builder.addTaskOnScenario('allowedPositions');
        builder.addTaskOnProperty('team');
        builder.addTaskOnProperty('competitionName');
        builder.addTaskOnProperty('exposureMin', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMin > 0;
        });
        builder.addTaskOnProperty('exposureMax', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMax < 100;
        });

        return builder.execTasks();
    }
}
